// Components
import HeaderWithBackButton from 'app/components/HeaderWithBackButton';
import PageLoader from 'app/components/PageLoader';
import NumberInput from 'app/components/UI/NumberInput';
import Button from 'app/components/button';
import Toggle from 'react-toggle';
import Dropdown from 'app/components/Dropdown';
import Checkbox from 'app/components/checkbox';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import useCreateFestiveTier from './useCreateFestiveTier';
import NewInput from 'app/components/NewInput';
import { commonMaxDate, commonMinDate } from 'app/utils/Parsers';

const CreateFestiveTier = () => {
  const {
    handleMallChange,
    handleChange,
    values,
    error,
    handleCreateFestiveTier,
    pageLoading,
    hideFields,
    mallList,
    masterList,
    setChange,
    supportId,
    navigate,
    handleCheckChange,
    toggleDayStatus,
    dayOfweek,
  } = useCreateFestiveTier();

  return (
    <div className='blogsForm'>
      <div className='blogsForm_content'>
        <HeaderWithBackButton
          title={` ${supportId ? ' Edit Festive Tier' : 'Create Festive Tier'}`}
          goTo={APP_CONSTANTS.TIER}
        />
        <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
          <div className='wd-50'>
            <label>Mange Tiers for Malls</label>
            <Dropdown
              id={'mallId'}
              label='Mall List*'
              name='mallId'
              options={mallList}
              placeholder='Select Mall '
              value={values?.mallId}
              handleChange={handleMallChange}
              isFieldHidden={hideFields}
              isDisabled={supportId ? true : false}
              errorText={error?.mallId}
            />
          </div>
          <div className='wd-100 mb-2'>
            <div className='d-flex'>
              {masterList?.map((item, index) => {
                return (
                  <Checkbox
                    id={item?.id}
                    label={item?.name}
                    checked={item?.checked}
                    onChange={handleCheckChange}
                    disabled={supportId ? true : false}
                  />
                );
              })}
            </div>
            <div>
              {masterList?.length > 0 && error?.parent && (
                <p className='loginWrapper-valid-text'>{error?.parent}</p>
              )}
            </div>
          </div>

          <div className='wd-50 '>
            <NewInput
              label='Promotional Tier Name*'
              id='name'
              placeholder='Tier Name'
              name='name'
              value={values?.name}
              errorText={error?.name}
              onChange={handleChange}
            />
          </div>
          <div className='wd-50'>
            <NumberInput
              label='Percentage points* (%)'
              id='discount'
              placeholder='Discount'
              name='discount'
              value={values?.discount}
              errorText={error?.discount}
              onChange={handleChange}
              takeDecimal={true}
            />
          </div>

          <div className='wd-50'>
            <NewInput
              label='Start Date*'
              id='startDate'
              placeholder='DD-YY-MMMM'
              name='startDate'
              format='DD-MM-YYYY'
              type={'date'}
              min={commonMinDate()}
              max={commonMaxDate()}
              value={values?.startDate}
              onChange={handleChange}
              errorText={error?.startDate}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='End Date*'
              name='endDate'
              id='endDate'
              placeholder={'End Date'}
              min={values.startDate ? values.startDate : commonMinDate()}
              max={commonMaxDate()}
              value={values?.endDate}
              type={'date'}
              onChange={handleChange}
              errorText={error?.endDate}
            />
          </div>
          <div className='wd-100'>
            <div className='d-block my-4'>
              <label className='me-2 d-inline-block tooltip-on-hover'>
                Status*
              </label>
              <label className='d-inline-block mt-2'>
                <div className='d-inline-flex align-items-center'>
                  <div className='d-inline-flex text-danger'>OFF</div>
                  <div className='d-inline-flex mx-2'>
                    <Toggle
                      checked={values.status}
                      icons={false}
                      onChange={() => setChange('status', !values.status)}
                    />
                  </div>
                  <div className='d-inline-flex text-green'>ON</div>
                </div>
              </label>
            </div>
          </div>

          <div className='wd-100 mb-2'>
            <label className='me-2 d-block tooltip-on-hover'>Day of Week</label>
          </div>
          <div className='weekdays-container wd-100'>
            {dayOfweek &&
              Object.keys(dayOfweek).map((day) => (
                <div
                  key={day}
                  className={`weekday-box ${
                    dayOfweek[day] ? 'active' : 'inactive'
                  }`}
                  onClick={() => toggleDayStatus(day)}
                >
                  {day[0]}
                </div>
              ))}
          </div>
          <div className='d-flex justify-content-start mt-4'>
            <Button
              className='mt1'
              onClick={handleCreateFestiveTier}
              variant='Save'
              name='Submit'
              isDisabled={pageLoading ? true : false}
            />

            <Button
              className='mt1 cancel-button ms-2'
              onClick={() => navigate(-1)}
              variant='Cancel'
              name='Cancel'
              isDisabled={pageLoading ? true : false}
            />
          </div>
        </div>
      </div>
      {pageLoading && <PageLoader pageLoading={pageLoading} />}
    </div>
  );
};

export default CreateFestiveTier;
